/* jshint esversion: 6 */
/* jshint esversion: 9 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from "axios";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import { LuChevronRight, LuPlus, LuMinus } from "react-icons/lu";
import { showToast } from "../../showTost";
import { FiMapPin, FiPlus } from "react-icons/fi";
import { IoCallOutline, IoChevronDown, IoClose } from "react-icons/io5";
import { TiLocation } from "react-icons/ti";
import Payment from "../../Payment/Payment";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import Wallet from "../../assets/Icon/wallet.svg";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";
import MapPin from "../../assets/Icon/mappin.svg";
import { MdOutlineMedicalServices } from "react-icons/md";

const axiosInstance = axios;

const Checkout = () => {
  const { t } = useTranslation();

  const {
    ApiBaseUrl,
    ImgBaseUrl,
    isPayment,
    setIsPayment,
    paymentStatus,
    setPaymentStatus,
    mapKey,
    setActivePage,
    transactionid,
  } = useContext(MyContext);
  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";

  const [productList, ProductList] = useState([]);
  const [details, setDetails] = useState("");
  const [isShow, setIsShow] = useState("");
  const [productId, setProductId] = useState("");
  const [isPhotoAdd, setIsPhotoAdd] = useState(false);
  const [isDriverSelected, setIsDriverSelected] = useState(false);
  const [myWallet, setMyWallet] = useState("");
  const [photos, setPhotos] = useState([]);
  const [isCouponShow, setIsCouponShow] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponList, setCouponList] = useState([]);
  const [shopTotal, setShopTotal] = useState("");
  const [isLocationShow, setIsLocationShow] = useState(false);
  const [isLocationShow2, setIsLocationShow2] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const [selectAddress, setSelectAddress] = useState("");
  const [comRate, setComRate] = useState("");
  const [value, setValue] = useState("");
  const [addressData, setAddressData] = useState({
    address: "",
    houseno: "",
    mobile: "",
    landmark: "",
    instruction: "",
    address_as: "",
  });
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [loading, setLoading] = useState(true);
  const [allData, setAllData] = useState("  ");
  const [detaillod, setDetailLod] = useState(false);
  const [showCcode, setShowCcode] = useState(false);
  const [searchCcode, setSearchCcode] = useState("");
  const [selectCcode, setSelectCcode] = useState("+91");

  const LocalData = sessionStorage.getItem("Docdetails");

  if (LocalData) {
    var { Docid } = JSON.parse(LocalData);
  }
  const Userid = secureLocalStorage.getItem("Userid");

  const InputRef = useRef(null);
  const navigate = useNavigate();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: mapKey,
  });

  const countries = getCountries();
  const FilterCCode = countries.filter((item) =>
    getCountryCallingCode(item).toString().includes(searchCcode),
  );

  const HandleGetAddress = useCallback(() => {
    if (Userid) {
      axiosInstance
        .post(`${ApiBaseUrl}/customer/address_list`, { id: Userid })
        .then((res) => {
          setAddressList(res.data.address_list);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [ApiBaseUrl, Userid]);

  const HandleGetCouponList = useCallback(() => {
    axiosInstance
      .post(`${ApiBaseUrl}/customer/coupon_list`, { doctor_id: Docid })
      .then((res) => {
        setCouponList(
          Array.isArray(res.data.coupon_list) ? res.data.coupon_list : [],
        );
      })
      .catch((error) => {
        console.error(error);
        setCouponList([]);
      });
  }, [ApiBaseUrl, Docid]);

  const HandleGetCommission = useCallback((data, price) => {
    if (data.commission_type === "fix") {
      setComRate({ rate: data.commission, type: data.commission_type });
    } else {
      const Rate = price / data.commission;
      setComRate({ rate: Rate, type: data.commission + data.commission_type });
    }
  }, []);

  const HandleFetchData = useCallback(() => {
    if (Userid) {
      axiosInstance
        .post(`${ApiBaseUrl}/customer/checkout_data`, {
          uid: Userid,
          doctor_id: Docid,
        })
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            setLoading(false);
            setMyWallet(res.data.wallet_amount);
            setShopTotal(res.data.tot_price);
            ProductList(res.data.product_list);
            HandleGetCommission(res.data.com_data, res.data.tot_price);
            const hasPrescription = res.data.product_list.some(
              (item) => item.prescription_require === "Required",
            );
            setIsPhotoAdd(hasPrescription);
            if (res.data.product_list.length <= 0) {
              navigate("/store-home");
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [ApiBaseUrl, Docid, Userid, navigate, HandleGetCommission]);

  useEffect(() => {
    window.scrollTo(0, 0);

    navigator.geolocation.getCurrentPosition((position) => {
      const lat = position.coords.latitude;
      const long = position.coords.longitude;
      setLatitude(lat);
      setLongitude(long);
    });

    HandleFetchData();
    HandleGetCouponList();
    HandleGetAddress();
  }, [HandleFetchData, HandleGetCouponList, HandleGetAddress]);

  // Derived calculations for checkout amounts
  const totalAmount2 = Number(comRate?.rate || 0) + Number(shopTotal || 0);
  const couponDiscount = couponCode ? Number(couponCode.amt || 0) : 0;
  const netAmountBeforeWallet = Math.max(0, totalAmount2 - couponDiscount);

  const wallet = isDriverSelected
    ? Math.min(Number(myWallet || 0), netAmountBeforeWallet)
    : 0;
  const totalAmount = Math.max(0, netAmountBeforeWallet - wallet);
  const myWallet2 = isDriverSelected
    ? Number(myWallet || 0) - wallet
    : Number(myWallet || 0);

  const HandleBookOrder = useCallback(() => {
    const PaymentId = sessionStorage.getItem("Paymentid");

    if (Userid) {
      const WalletAmount = wallet;
      const TotalPrice = couponCode
        ? totalAmount2 - couponCode.amt
        : totalAmount2;

      const Data = {
        uid: Userid,
        doctor_id: Docid,
        tot_price: TotalPrice,
        coupon: couponCode ? couponCode.id : "",
        coupon_amount: couponCode ? couponCode.amt : 0,
        site_commission: comRate.rate,
        address: selectAddress.id,
        wallet_amount: WalletAmount ? WalletAmount : 0,
        payment_id: PaymentId ? PaymentId : "",
        transactionId: sessionStorage.getItem("transactionId") || transactionid || "",
      };

      axiosInstance
        .post(`${ApiBaseUrl}/customer/add_product_order`, Data)
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            showToast({ title: res.data.message, id: "success" });
            navigate("/order");
            setActivePage(2);
            sessionStorage.removeItem("Paymentid");
            sessionStorage.removeItem("transactionId");
          } else {
            showToast({ title: res.data.message || t("Order Failed"), id: "error" });
          }
        })
        .catch((error) => {
          console.error(error);
          showToast({ title: error?.response?.data?.message || t("Order Request Failed"), id: "error" });
        });
    }
  }, [
    ApiBaseUrl,
    Docid,
    Userid,
    isDriverSelected,
    couponCode,
    totalAmount2,
    totalAmount,
    wallet,
    comRate,
    selectAddress,
    transactionid,
    navigate,
    setActivePage,
  ]);

  const HandleAddPrescription = useCallback(() => {
    if (Userid) {
      const formData = new FormData();
      formData.append("uid", Userid);
      formData.append("doctor_id", Docid);

      photos.forEach((photo) => {
        formData.append("image", photo);
      });

      axiosInstance
        .post(`${ApiBaseUrl}/customer/add_patient_prescription`, formData)
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            HandleBookOrder();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [ApiBaseUrl, Docid, Userid, photos, HandleBookOrder]);

  const HandleBooking = useCallback(() => {
    if (isPhotoAdd) {
      HandleAddPrescription();
    } else {
      HandleBookOrder();
    }
  }, [isPhotoAdd, HandleAddPrescription, HandleBookOrder]);

  const HandleDetails = (item) => {
    if (isDriverSelected) {
      setIsDriverSelected(!isDriverSelected);
    }
    setIsShow({ name: item.product_name, img: item.product_image });
    setDetails(item.price_detail);
    setProductId(item.id);
  };

  const HandleRemovePhoto = (index) => {
    const Copy = [...photos];
    Copy.splice(index, 1);
    setPhotos(Copy);
  };

  const HandleCoupanAdd = (code, amt, id) => {
    setCouponCode({ code, amt, id });
    showToast({ title: t("Coupon Add Successful"), id: "success" });
    setIsCouponShow(false);
  };

  const HandleCoupanRemove = () => {
    if (couponCode) {
      setCouponCode("");
    } else {
      setIsCouponShow(true);
    }
    if (isDriverSelected) {
      setIsDriverSelected(!isDriverSelected);
    }
  };

  const HandleContinuePayment = () => {
    if (isPhotoAdd && photos.length === 0) {
      showToast({ title: t("Add patient prescription"), id: "error" });
      return;
    }

    if (!selectAddress) {
      showToast({ title: t("Select deliver address"), id: "error" });
      return;
    }

    if (isDriverSelected && totalAmount === 0) {
      HandleBooking();
    } else {
      setIsPayment(true);
    }

    const WalletAmount = wallet;
    const TotalPrice = couponCode
      ? totalAmount2 - couponCode.amt
      : totalAmount2;

    const Data = {
      uid: Userid,
      doctor_id: Docid,
      tot_price: TotalPrice,
      coupon: couponCode ? couponCode.id : "",
      coupon_amount: couponCode ? couponCode.amt : 0,
      site_commission: comRate.rate,
      address: selectAddress.id,
      wallet_amount: WalletAmount ? WalletAmount : 0,
    };

    setAllData(Data);
    sessionStorage.setItem("page", "3");
  };

  useEffect(() => {
    if (!paymentStatus) return;
    if (paymentStatus === "PaymentDone") {
      HandleBooking();
      setPaymentStatus("");
      setIsPayment(false);
    }
  }, [paymentStatus, HandleBooking, setPaymentStatus, setIsPayment]);

  const HandleSaveAddress = async () => {
    if (
      !addressData.address &&
      !addressData.houseno &&
      !addressData.landmark &&
      !addressData.instruction &&
      !addressData.address_as
    ) {
      showToast({ title: t("Please Enter Details"), id: "error" });
      return;
    }

    if (!value) {
      showToast({ title: t("Please Enter Details"), id: "error" });
      return;
    }

    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      const Data = {
        id: Userid,
        house_no: addressData.houseno,
        address: addressData.address,
        landmark: addressData.landmark,
        address_as: addressData.address_as,
        country_code: selectCcode,
        phone: value,
        latitude: latitude,
        longitude: longitude,
        google_address: await HandleGetGoogleAddress(latitude, longitude),
        instruction: addressData.instruction,
      };

      axiosInstance
        .post(`${ApiBaseUrl}/customer/add_address`, Data)
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            setIsLocationShow2("");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleGetGoogleAddress = async (lat, long) => {
    try {
      const response = await axiosInstance.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${mapKey}`,
      );
      const address = response.data.results[0]?.formatted_address;
      return address;
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setLatitude(lat);
    setLongitude(lng);
  };

  useEffect(() => {
    loading
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [loading]);

  const handleSelectCuntryCode = async (item) => {
    setSelectCcode(`+${getCountryCallingCode(item)}`);
    setShowCcode(false);
  };

  return (
    <div className="width-container pb-[50px] content-wrapper lab-details px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" />
      ) : (
        <div className="flex flex-col">
          {/* Header Navigation Section */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
            <Link
              to="/"
              className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
            >
              <IoIosArrowBack className="w-4 h-4" />
              <span className="font-medium text-sm">{t("Go Home")}</span>
            </Link>

            <div className="flex items-center gap-2 text-sm text-slate-500">
              <Link
                to="/store-home"
                className="hover:text-indigo-600 font-medium transition-colors"
              >
                {t("Shop Home Page")}
              </Link>
              <IoIosArrowForward className="w-3.5 h-3.5" />
              <span className="font-semibold text-slate-800">
                {t("Checkout")}
              </span>
            </div>
          </div>

          {/* Checkout Body Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-4">
            {/* Left Column */}
            <div className="flex flex-col gap-6">
              {/* Order Details List */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm">
                <h2 className="font-bold text-slate-800 text-lg mb-4">
                  {t("Order Details")}
                </h2>
                <div className="flex flex-col gap-4">
                  {productList.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 py-4 border-b border-slate-100 last:border-0 last:pb-0 first:pt-0"
                      >
                        <div className="flex items-center gap-4">
                          <div className="relative group overflow-hidden rounded-xl border border-slate-200 bg-white p-1 shrink-0">
                            <ImageLoad
                              src={ImgBaseUrl + item.product_image}
                              CustomeStyle={
                                "w-[64px] h-[64px] object-contain rounded-lg transition-transform duration-300 group-hover:scale-105"
                              }
                              alt={item.product_name}
                            />
                          </div>
                          <div className="leading-snug">
                            {item.prescription_require === "Required" && (
                              <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-rose-600 bg-rose-50 border border-rose-100 px-2 py-0.5 rounded-full mb-1.5">
                                <MdOutlineMedicalServices className="w-3.5 h-3.5" />
                                {t("Prescription Required")}
                              </span>
                            )}
                            <h3 className="font-bold text-slate-800 text-base">
                              {item.product_name}
                            </h3>
                            <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-0.5 rounded-md inline-block mt-0.5">
                              {item.pro_type}
                            </span>

                            <div className="flex items-baseline gap-2 mt-2">
                              <span className="font-bold text-slate-900 text-base">
                                {currency}
                                {item.price_detail[0].price}
                              </span>
                              {item.price_detail[0].base_price &&
                                item.price_detail[0].base_price !==
                                  item.price_detail[0].price && (
                                  <span className="line-through text-slate-400 text-xs">
                                    {currency}
                                    {item.price_detail[0].base_price}
                                  </span>
                                )}
                              {item.price_detail[0].discount !== 0 && (
                                <span className="bg-orange-50 text-orange-600 border border-orange-100 px-2 py-0.5 rounded-full text-[10px] font-semibold ml-1">
                                  {item.price_detail[0].discount}% OFF
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="flex sm:flex-col items-center justify-between sm:justify-start gap-2 shrink-0">
                          <button
                            onClick={() => HandleDetails(item)}
                            className="flex items-center justify-center min-w-[90px] h-9 border rounded-full font-medium transition-all duration-200 bg-indigo-50 border-indigo-200 text-indigo-700 hover:bg-indigo-100 active:scale-95"
                          >
                            <span className="text-xs font-semibold px-3 flex items-center gap-1.5">
                              <LuPlus className="w-3.5 h-3.5" />
                              {t("Edit")}
                            </span>
                          </button>
                          <span className="text-xs text-slate-400 font-medium">
                            {item.price_detail.length}{" "}
                            {item.price_detail.length === 1
                              ? t("Option")
                              : t("Options")}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Prescription Upload Panel */}
              {isPhotoAdd && (
                <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="font-bold text-slate-800 text-lg">
                      {t("Your Uploaded Prescription")}
                    </h2>
                    {photos?.length >= 1 && (
                      <button
                        onClick={() => InputRef.current?.click()}
                        className="text-indigo-650 hover:text-indigo-750 font-semibold text-sm transition-colors"
                      >
                        {t("+ Add More")}
                      </button>
                    )}
                  </div>

                  <div>
                    {photos?.length === 0 ? (
                      <div
                        onClick={() => InputRef.current?.click()}
                        className="border-2 border-dashed border-indigo-200 hover:border-indigo-400 bg-indigo-50/20 hover:bg-indigo-50/50 rounded-2xl p-6 transition-all duration-200 flex flex-col items-center justify-center cursor-pointer text-center"
                      >
                        <svg
                          className="w-8 h-8 text-indigo-500 mb-2"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 4v16m8-8H4"
                          />
                        </svg>
                        <span className="text-indigo-650 font-bold text-sm">
                          {t("Upload Prescription")}
                        </span>
                        <span className="text-slate-400 text-xs mt-1">
                          {t("Image formats (PNG, JPG) up to 5MB")}
                        </span>
                      </div>
                    ) : (
                      <div className="pt-2 flex items-center gap-4 overflow-x-auto scroll-container pb-2">
                        {photos?.map((item, index) => (
                          <div
                            key={index}
                            className="relative group shrink-0 rounded-xl overflow-hidden shadow-sm border border-slate-100 bg-slate-50 p-1"
                          >
                            <ImageLoad
                              src={URL.createObjectURL(item)}
                              CustomeStyle={"w-20 h-20 object-cover rounded-lg"}
                              alt={"prescription"}
                            />
                            <button
                              onClick={() => HandleRemovePhoto(index)}
                              className="absolute top-1.5 right-1.5 p-1 bg-rose-500 hover:bg-rose-600 text-white rounded-full transition-colors shadow-md flex items-center justify-center"
                              aria-label="Remove photo"
                            >
                              <IoClose className="w-3.5 h-3.5" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <input
                    ref={InputRef}
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setPhotos([...photos, e.target.files[0]]);
                      }
                      e.target.value = null;
                    }}
                    accept="image/*"
                    type="file"
                    className="hidden"
                  />
                </div>
              )}
            </div>

            {/* Right Column */}
            <div className="flex flex-col gap-6">
              {/* Pay from Wallet Switch */}
              {Number(myWallet) > 0 && (
                <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="font-bold text-slate-800 text-lg">
                      {t("Pay from Wallet")}
                    </h2>
                    <label className="relative inline-flex items-center cursor-pointer select-none">
                      <input
                        type="checkbox"
                        checked={isDriverSelected}
                        onChange={() => setIsDriverSelected(!isDriverSelected)}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                    </label>
                  </div>

                  <div className="border border-indigo-100 bg-indigo-50/20 p-4 rounded-2xl flex items-center justify-between shadow-inner">
                    <div className="flex items-center gap-3">
                      <div className="bg-indigo-100 p-2.5 rounded-xl text-indigo-650 flex items-center justify-center">
                        <img src={Wallet} className="w-6 h-6" alt="" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-slate-800 text-base">
                          {t("My Wallet")}
                        </h3>
                        <p className="text-slate-400 text-xs">
                          {t("Available balance")}
                        </p>
                      </div>
                    </div>
                    <span className="font-bold text-indigo-600 text-xl">
                      {currency}
                      {isDriverSelected ? myWallet2 : myWallet}.00
                    </span>
                  </div>
                </div>
              )}

              {/* Coupon Section */}
              {Array.isArray(couponList) && couponList.length > 0 && (
                <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm">
                  <div className="flex items-center justify-between border-b border-slate-100 pb-4 mb-4">
                    <div className="flex items-center gap-3">
                      <div className="bg-emerald-50 border border-emerald-100 p-2.5 rounded-xl text-emerald-600 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          stroke="none"
                        >
                          <path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path>
                        </svg>
                      </div>
                      <div>
                        <h3 className="font-bold text-slate-800 text-base">
                          {t("Apply Coupon")}
                        </h3>
                        {couponCode ? (
                          <p className="text-xs text-slate-505">
                            {t("Use Code")} :{" "}
                            <span className="font-bold text-indigo-650 bg-indigo-50 px-1.5 py-0.5 rounded">
                              {couponCode.code}
                            </span>
                          </p>
                        ) : (
                          <p className="text-xs text-slate-400">
                            {t("Save money on your order")}
                          </p>
                        )}
                      </div>
                    </div>
                    <button
                      onClick={HandleCoupanRemove}
                      className={`font-semibold text-sm transition-colors py-1.5 px-4 rounded-full border ${couponCode ? "text-rose-600 border-rose-200 bg-rose-50/20 hover:bg-rose-50" : "text-indigo-650 border-indigo-200 hover:bg-indigo-50/30"}`}
                    >
                      {couponCode ? t("Remove") : t("Apply")}
                    </button>
                  </div>
                  <div
                    onClick={() => !couponCode && setIsCouponShow(true)}
                    className="flex items-center justify-between py-1 cursor-pointer group text-slate-500 hover:text-indigo-650 transition-colors"
                  >
                    <span className="text-sm font-medium">
                      {t("View All Coupons")}
                    </span>
                    <LuChevronRight className="text-slate-400 group-hover:text-indigo-650 group-hover:translate-x-0.5 transition-all w-5 h-5" />
                  </div>
                </div>
              )}

              {/* Delivery Address Panel */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h2 className="font-bold text-slate-800 text-lg mb-1">
                      {selectAddress
                        ? selectAddress.address
                        : t("Select Delivery Address")}
                    </h2>
                    <p className="text-slate-400 text-xs leading-relaxed">
                      {t("We deliver the product to this address.")}
                    </p>
                  </div>
                  <button
                    onClick={() => setIsLocationShow(true)}
                    className="flex items-center gap-1.5 border border-slate-200 p-2.5 rounded-xl hover:bg-slate-50 transition-colors text-indigo-600 shadow-sm shrink-0"
                    aria-label="Change address"
                  >
                    <FiMapPin className="text-xl" />
                    <IoChevronDown className="text-sm" />
                  </button>
                </div>
              </div>

              {/* Invoice Breakdown Summary */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-4">
                <h2 className="font-bold text-slate-800 text-lg pb-2 border-b border-slate-100">
                  {t("Order Summary")}
                </h2>

                <div className="flex items-center justify-between text-sm text-slate-500">
                  <span>{t("Shop Total")}</span>
                  <span className="font-bold text-slate-800">
                    {currency}
                    {String(shopTotal).padStart(2, "0")}
                  </span>
                </div>

                {isDriverSelected && (
                  <div className="flex items-center justify-between text-sm text-emerald-600 bg-emerald-50/50 px-3 py-1.5 rounded-lg border border-emerald-100/50">
                    <span className="font-medium">{t("Wallet Deducted")}</span>
                    <span className="font-bold">
                      -{currency}
                      {String(wallet).padStart(2, "0")}
                    </span>
                  </div>
                )}

                {couponCode && (
                  <div className="flex items-center justify-between text-sm text-emerald-600 bg-emerald-50/50 px-3 py-1.5 rounded-lg border border-emerald-100/50">
                    <span className="font-medium">{t("Coupon Discount")}</span>
                    <span className="font-bold">
                      -{currency}
                      {couponCode.amt}
                    </span>
                  </div>
                )}

                <div className="flex items-center justify-between text-sm text-slate-500">
                  <span>
                    {t("Commission Rate")} ({comRate?.type})
                  </span>
                  <span className="font-bold text-slate-800">
                    +{currency}
                    {String(comRate?.rate).padStart(2, "0")}
                  </span>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-slate-100 mt-2">
                  <span className="text-base font-bold text-slate-800">
                    {t("Total Payable Amount")}
                  </span>
                  <span className="font-bold text-indigo-600 text-xl">
                    {currency}
                    {String(totalAmount).padStart(2, "0")}
                  </span>
                </div>
              </div>

              {/* Action Button Section */}
              <div className="bg-slate-50 rounded-3xl p-6 border border-slate-150 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 shadow-inner">
                <div>
                  <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">
                    {t("Grand Total")}
                  </span>
                  <h3 className="font-bold text-slate-900 text-2xl mt-0.5">
                    {currency}
                    {totalAmount}
                  </h3>
                </div>
                <button
                  onClick={HandleContinuePayment}
                  className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-base min-w-[240px] py-4 px-6 rounded-full active:scale-[0.99] transition-all duration-200 text-center tracking-wide"
                >
                  {t("Proceed to Payment")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Centered Variant Selector Modal */}
      {isShow && (
        <div
          onClick={() => setIsShow("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-lg w-full max-h-[85vh] flex flex-col p-6 relative animate-in fade-in duration-200"
          >
            {/* Close Button */}
            <button
              onClick={() => setIsShow("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close modal"
            >
              <IoClose className="w-5 h-5" />
            </button>

            <div className="mb-4 pr-8">
              <span className="text-xs font-semibold uppercase tracking-wider text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-md inline-block mb-1">
                {t("Select Variant")}
              </span>
              <h1 className="font-bold text-slate-800 text-lg md:text-xl line-clamp-1">
                {isShow.name}
              </h1>
            </div>

            <div className="flex-1 overflow-y-auto scroll-container pr-1 py-1 max-h-[420px]">
              {details.map((item, index) => {
                return (
                  <DetailsList
                    key={index}
                    item={item}
                    index={index}
                    ImgBaseUrl={ImgBaseUrl}
                    isShow={isShow}
                    currency={currency}
                    detaillod={detaillod}
                    setDetailLod={setDetailLod}
                    Userid={Userid}
                    Docid={Docid}
                    productId={productId}
                    details={details}
                    ApiBaseUrl={ApiBaseUrl}
                    HandleFetchData={HandleFetchData}
                    setDetails={setDetails}
                    setIsShow={setIsShow}
                  />
                );
              })}
            </div>

            <div className="mt-6 pt-4 border-t border-slate-100">
              <button
                onClick={() => setIsShow("")}
                className="w-full bg-slate-900 hover:bg-slate-800 text-white font-semibold text-base rounded-full py-3.5 shadow-md hover:shadow-lg active:scale-[0.99] transition-all duration-200"
              >
                {t("Done")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Centered Coupon List Modal */}
      {isCouponShow && (
        <div
          onClick={() => setIsCouponShow(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-md w-full max-h-[85vh] flex flex-col p-6 relative animate-in fade-in duration-200"
          >
            {/* Close Button */}
            <button
              onClick={() => setIsCouponShow(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close modal"
            >
              <IoClose className="w-5 h-5" />
            </button>

            <div className="mb-4 pr-8">
              <span className="text-xs font-semibold uppercase tracking-wider text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-md inline-block mb-1">
                {t("Discount Offer")}
              </span>
              <h1 className="font-bold text-slate-800 text-lg md:text-xl">
                {t("Best Coupons")}
              </h1>
            </div>

            <div className="flex-1 overflow-y-auto scroll-container pr-1 py-1 max-h-[420px] flex flex-col gap-3">
              {couponList.map((item, index) => {
                const isApplicable = totalAmount2 >= item.min_amount;
                return (
                  <div
                    key={index}
                    className="border border-slate-100 bg-slate-50 rounded-2xl p-5 hover:border-indigo-150 transition-all duration-200 shadow-sm flex flex-col gap-3"
                  >
                    <div className="flex items-start justify-between gap-4">
                      <div>
                        <h3 className="font-extrabold text-slate-800 text-base leading-tight">
                          {item.title}
                        </h3>
                        <p className="text-slate-500 text-xs mt-1 leading-relaxed">
                          {item.sub_title}
                        </p>
                      </div>

                      <div className="text-indigo-600 bg-indigo-50 p-2.5 rounded-xl shrink-0 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          stroke="none"
                        >
                          <path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path>
                        </svg>
                      </div>
                    </div>

                    <div className="bg-white border border-slate-100 rounded-xl p-3 flex flex-col gap-1.5 text-xs text-slate-500 shadow-inner">
                      <div>
                        {t("Coupon Code")}:{" "}
                        <span className="font-bold text-indigo-650 bg-indigo-50 px-1.5 py-0.5 rounded">
                          {item.code}
                        </span>
                      </div>
                      <div>
                        {t("Coupon Amount")}:{" "}
                        <span className="font-bold text-slate-700">
                          {currency}
                          {item.discount_amount}
                        </span>
                      </div>
                      <div>
                        {t("Minimum Order")}:{" "}
                        <span className="font-bold text-slate-700">
                          {currency}
                          {item.min_amount}
                        </span>
                      </div>
                      <div>
                        {t("Expiry Date")}:{" "}
                        <span className="font-bold text-slate-700">
                          {item.end_date}
                        </span>
                      </div>
                    </div>

                    <button
                      disabled={!isApplicable}
                      onClick={() =>
                        HandleCoupanAdd(
                          item.code,
                          item.discount_amount,
                          item.id,
                        )
                      }
                      className={`w-full py-3 rounded-full font-bold text-sm tracking-wide transition-all duration-200 ${isApplicable ? "bg-indigo-600 text-white hover:bg-indigo-750 shadow-sm" : "bg-slate-200 text-slate-400 cursor-not-allowed"}`}
                    >
                      {isApplicable
                        ? t("Apply Coupon")
                        : t("Order amount too low")}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Centered Delivery Address List Modal */}
      {isLocationShow && (
        <div
          onClick={() => setIsLocationShow("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-md w-full max-h-[85vh] flex flex-col p-6 relative animate-in fade-in duration-200"
          >
            {/* Close Button */}
            <button
              onClick={() => setIsLocationShow("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close modal"
            >
              <IoClose className="w-5 h-5" />
            </button>

            <div className="mb-4 pr-8">
              <span className="text-xs font-semibold uppercase tracking-wider text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-md inline-block mb-1">
                {t("Deliver To")}
              </span>
              <h1 className="font-bold text-slate-800 text-lg md:text-xl mb-4">
                {t("Choose a Delivery Address")}
              </h1>

              <button
                onClick={() => {
                  setIsLocationShow2(true);
                  setIsLocationShow("");
                }}
                className="w-full flex items-center justify-center gap-2 border-2 border-dashed border-indigo-200 hover:border-indigo-400 bg-indigo-50/10 hover:bg-indigo-50/30 text-indigo-600 font-bold text-sm py-3 px-4 rounded-xl transition-all duration-200"
              >
                <FiPlus className="text-lg" />
                <span>{t("Add New Address")}</span>
              </button>
            </div>

            <div className="flex-1 overflow-y-auto scroll-container pr-1 py-1 max-h-[360px] flex flex-col gap-3">
              {addressList.length >= 1 ? (
                addressList.map((ietm, index) => {
                  return (
                    <div
                      onClick={() => {
                        setSelectAddress({
                          address: ietm.address,
                          id: ietm.id,
                        });
                        setIsLocationShow("");
                      }}
                      key={index}
                      className="border border-slate-100 bg-slate-50 rounded-2xl p-4 cursor-pointer hover:border-indigo-200 hover:bg-indigo-50/10 transition-all duration-200 shadow-sm flex flex-col gap-2"
                    >
                      <h3 className="font-bold text-slate-800 text-sm md:text-base">
                        {ietm.address_as} {t("Address")}
                      </h3>
                      <div className="flex items-center gap-2 text-slate-500">
                        <IoCallOutline className="text-emerald-550 text-lg shrink-0" />
                        <span className="font-semibold text-xs md:text-sm">
                          {ietm.country_code} {ietm.phone}
                        </span>
                      </div>
                      <div className="flex items-start gap-2 text-slate-700">
                        <TiLocation className="text-indigo-600 text-lg shrink-0 mt-0.5" />
                        <span className="font-semibold text-xs md:text-sm leading-relaxed">
                          {ietm.address}
                        </span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="h-[200px] flex flex-col items-center justify-center text-center text-slate-400">
                  <TiLocation className="w-10 h-10 text-slate-300 mb-2" />
                  <p className="text-sm font-semibold">
                    {t("No saved address found")}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Centered Add Location Modal with Google Map */}
      {isLocationShow2 && (
        <div
          onClick={() => setIsLocationShow2("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-lg w-full max-h-[90vh] flex flex-col p-6 relative overflow-y-auto scroll-container animate-in fade-in duration-200"
          >
            {/* Close Button */}
            <button
              onClick={() => setIsLocationShow2("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close modal"
            >
              <IoClose className="w-5 h-5" />
            </button>

            <div className="mb-4">
              <span className="text-xs font-semibold uppercase tracking-wider text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-md inline-block mb-1">
                {t("Location Pin")}
              </span>
              <h1 className="font-bold text-slate-800 text-lg md:text-xl">
                {t("Add Delivery Address")}
              </h1>
            </div>

            {/* Google Map Wrapper */}
            <div className="relative rounded-2xl overflow-hidden border border-slate-150 bg-slate-50 h-[200px] mb-4">
              {isLoaded && (
                <GoogleMap
                  center={{
                    lat: latitude || 21.1702,
                    lng: longitude || 72.8311,
                  }}
                  zoom={15}
                  onClick={handleMapClick}
                  mapContainerClassName="w-full h-full"
                >
                  <Marker
                    icon={{
                      url: MapPin,
                      scaledSize: new window.google.maps.Size(25, 25),
                    }}
                    position={{
                      lat: latitude || 21.1702,
                      lng: longitude || 72.8311,
                    }}
                  />
                </GoogleMap>
              )}
            </div>

            {/* Address fields */}
            <div className="flex flex-col gap-3">
              <div>
                <span className="text-xs font-semibold text-slate-450 block mb-1">
                  {t("Complete Address")}
                </span>
                <textarea
                  onChange={(e) =>
                    setAddressData({ ...addressData, address: e.target.value })
                  }
                  className="min-h-[60px] max-h-[100px] w-full border border-slate-200 outline-none rounded-xl p-3 focus:border-indigo-650 transition-colors text-sm text-slate-700 bg-slate-50"
                  placeholder={t("Street address, sector, apartment")}
                />
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <span className="text-xs font-semibold text-slate-455 block mb-1">
                    {t("House No")}
                  </span>
                  <input
                    onChange={(e) =>
                      setAddressData({
                        ...addressData,
                        houseno: e.target.value,
                      })
                    }
                    className="w-full border border-slate-200 outline-none rounded-xl p-3 focus:border-indigo-650 transition-colors text-sm text-slate-700 bg-slate-50"
                    type="text"
                    placeholder={t("Flat/House No")}
                  />
                </div>
                <div>
                  <span className="text-xs font-semibold text-slate-455 block mb-1">
                    {t("Landmark")}
                  </span>
                  <input
                    onChange={(e) =>
                      setAddressData({
                        ...addressData,
                        landmark: e.target.value,
                      })
                    }
                    className="w-full border border-slate-200 outline-none rounded-xl p-3 focus:border-indigo-650 transition-colors text-sm text-slate-700 bg-slate-50"
                    type="text"
                    placeholder={t("Eg: near park")}
                  />
                </div>
              </div>

              <div>
                <span className="text-xs font-semibold text-slate-455 block mb-1">
                  {t("Mobile Number")}
                </span>
                <div className="border border-slate-200 focus-within:border-indigo-650 rounded-xl p-3 flex items-center relative bg-slate-50">
                  <div
                    onClick={() => setShowCcode(!showCcode)}
                    className="flex items-center gap-1 cursor-pointer select-none shrink-0"
                  >
                    <span className="text-sm font-semibold text-slate-700">
                      {selectCcode}
                    </span>
                    <IoChevronDown className="w-3.5 h-3.5 text-slate-400" />
                  </div>
                  <input
                    type="tel"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="w-full bg-transparent outline-none px-3 text-sm text-slate-700"
                    placeholder={t("Mobile Number")}
                  />

                  {showCcode && (
                    <div className="absolute left-3 top-full mt-1 z-[888] w-[120px] bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden">
                      <input
                        type="number"
                        value={searchCcode}
                        onChange={(e) => setSearchCcode(e.target.value)}
                        className="w-full px-3 py-2 outline-none border-b border-slate-100 text-xs font-semibold"
                        placeholder={t("Search")}
                      />
                      <ul className="max-h-[150px] overflow-y-auto scroll-container">
                        {FilterCCode.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => handleSelectCuntryCode(item)}
                            className="px-3 py-1.5 cursor-pointer hover:bg-slate-50 text-xs font-semibold text-slate-650"
                          >
                            +{getCountryCallingCode(item)}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                {showCcode && (
                  <div
                    onClick={() => setShowCcode(false)}
                    className="fixed inset-0 z-[777]"
                  ></div>
                )}
              </div>

              <div>
                <span className="text-xs font-semibold text-slate-455 block mb-1">
                  {t("How to Reach Instructions (Optional)")}
                </span>
                <textarea
                  onChange={(e) =>
                    setAddressData({
                      ...addressData,
                      instruction: e.target.value,
                    })
                  }
                  className="min-h-[50px] max-h-[80px] w-full border border-slate-200 outline-none rounded-xl p-3 focus:border-indigo-650 transition-colors text-sm text-slate-700 bg-slate-50"
                  placeholder={t("Delivery notes")}
                />
              </div>

              <div>
                <span className="text-xs font-semibold text-slate-455 block mb-1">
                  {t("Save Address As")}
                </span>
                <input
                  onChange={(e) =>
                    setAddressData({
                      ...addressData,
                      address_as: e.target.value,
                    })
                  }
                  className="w-full border border-slate-200 outline-none rounded-xl p-3 focus:border-indigo-650 transition-colors text-sm text-slate-700 bg-slate-50"
                  type="text"
                  placeholder={t("Eg: Home, Work")}
                />
              </div>
            </div>

            <button
              onClick={HandleSaveAddress}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm rounded-full py-3.5 shadow-md hover:shadow-lg active:scale-[0.99] transition-all duration-200 mt-6"
            >
              {t("Save Address")}
            </button>
          </div>
        </div>
      )}

      {/* Centered Payment Selection Modal */}
      {isPayment && (
        <div
          onClick={() => setIsPayment(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-md w-full p-6 relative animate-in fade-in duration-200"
          >
            {/* Close Button */}
            <button
              onClick={() => setIsPayment(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close modal"
            >
              <IoClose className="w-5 h-5" />
            </button>

            <div className="mb-4 pr-8">
              <h1 className="font-bold text-slate-800 text-lg md:text-xl">
                {t("Select Payment Method")}
              </h1>
            </div>

            <div className="mt-4">
              <Payment
                Amount={totalAmount}
                INDEX={16}
                Data={allData}
                photos={photos}
                did={Docid}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout;
/* jshint ignore:end */

const DetailsList = ({
  item,
  index,
  ImgBaseUrl,
  isShow,
  currency,
  detaillod,
  setDetailLod,
  Userid,
  Docid,
  productId,
  details,
  ApiBaseUrl,
  HandleFetchData,
  setDetails,
  setIsShow,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const handleAddToCart = (item) => {
    if (!Userid && detaillod) return;

    const payload = {
      uid: Userid,
      doctor_id: Docid,
      prod_id: productId,
      pro_price: item.price,
      pro_ptype: item.title,
      pro_qty: item.cart_qty,
      pro_qty_type: 1,
      mode: 1,
    };

    setDetailLod(true);
    setLoading(true);

    const updatedDetails = details.map((detail) =>
      detail.title === item.title
        ? { ...detail, cart_qty: detail.cart_qty + 1 }
        : detail,
    );

    axiosInstance
      .post(`${ApiBaseUrl}/customer/cart_detail`, payload)
      .then((response) => {
        if (response.data.ResponseCode === 200) {
          HandleFetchData();
          setDetails(updatedDetails);
        }
        setDetailLod(false);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to add item to cart:", error);
        setDetailLod(false);
        setLoading(false);
      });
  };

  const handleRemoveToCart = (item) => {
    if (!Userid && detaillod) return;

    const payload = {
      uid: Userid,
      doctor_id: Docid,
      prod_id: productId,
      pro_price: item.price,
      pro_ptype: item.title,
      pro_qty: item.cart_qty,
      pro_qty_type: 2,
      mode: 1,
    };

    setDetailLod(true);
    setLoading(true);

    const updatedDetails = details.map((detail) =>
      detail.title === item.title
        ? { ...detail, cart_qty: detail.cart_qty - 1 }
        : detail,
    );

    axiosInstance
      .post(`${ApiBaseUrl}/customer/cart_detail`, payload)
      .then((response) => {
        if (response.data.ResponseCode === 200) {
          HandleFetchData();
          setDetails(updatedDetails);
          if (item.cart_qty === 1) {
            setIsShow("");
          }
        }
        setDetailLod(false);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to remove item from cart:", error);
        setDetailLod(false);
        setLoading(false);
      });
  };

  return (
    <div
      key={index}
      className="bg-slate-50 hover:bg-slate-100/60 border border-slate-100/80 rounded-2xl p-4 transition-all duration-200 shadow-sm flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-3"
    >
      <div className="flex items-center gap-4">
        <div className="relative group overflow-hidden rounded-xl border border-slate-200/60 bg-white p-1">
          <ImageLoad
            src={ImgBaseUrl + isShow.img}
            CustomeStyle={
              "w-[72px] h-[72px] object-contain rounded-lg transition-transform duration-300 group-hover:scale-105"
            }
            alt={"img"}
          />
        </div>
        <div className="leading-snug">
          <h2 className="font-semibold text-slate-800 text-[16px]">
            {isShow.name}
          </h2>
          <span className="text-xs font-medium px-2 py-0.5 bg-slate-200/60 text-slate-600 rounded-md inline-block mt-1">
            {item.title}
          </span>
          <div className="flex items-baseline gap-2 mt-2">
            <span className="font-bold text-slate-900 text-lg">
              {currency}
              {item.price}
            </span>
            {item.base_price && item.base_price !== item.price && (
              <span className="line-through text-slate-400 text-sm">
                {currency}
                {item.base_price}
              </span>
            )}
            {item.discount !== 0 && (
              <span className="bg-orange-50 text-orange-600 border border-orange-100 px-2 py-0.5 rounded-full text-xs font-semibold ml-1.5">
                {item.discount}% OFF
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-end sm:justify-start">
        <div
          className={`flex items-center justify-center min-w-[100px] h-10 border transition-all duration-200 rounded-full font-medium ${item.cart_qty ? "bg-indigo-50 border-indigo-200 text-indigo-700" : "bg-indigo-600 border-indigo-600 hover:bg-indigo-700 text-white shadow-sm hover:shadow"}`}
        >
          {loading ? (
            <div className="px-5 py-2">
              <div className="loader2 mx-auto"></div>
            </div>
          ) : item.cart_qty ? (
            <div className="flex items-center justify-between w-full px-2 gap-3">
              <button
                onClick={() => handleRemoveToCart(item)}
                className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-indigo-200/50 text-indigo-700 active:scale-90 transition-all duration-150"
                aria-label="Decrease quantity"
              >
                <LuMinus className="w-4 h-4" />
              </button>
              <span className="font-semibold text-base select-none">
                {item.cart_qty}
              </span>
              <button
                onClick={() => handleAddToCart(item)}
                className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-indigo-200/50 text-indigo-700 active:scale-90 transition-all duration-150"
                aria-label="Increase quantity"
              >
                <LuPlus className="w-4 h-4" />
              </button>
            </div>
          ) : (
            <button
              onClick={() => handleAddToCart(item)}
              className="w-full h-full text-center text-sm font-semibold tracking-wide uppercase px-5"
            >
              {t("Add")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
